import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimplessaudagartomumbaicab() {



const cardData = {
  keyword: " Pimple Saudagar to Mumbai Cab Service  ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Pimple Saudagar to Mumbai cab service, ensuring a hassle-free and smooth journey for business trips, airport transfers, family outings, or leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make your travel from Pimple Saudagar to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for cab travel to Mumbai.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "The Gateway of India is one of Mumbai’s most iconic landmarks along the Arabian Sea in South Mumbai. Travelers using a Pimple Saudagar to Mumbai cab service can easily reach this historic monument for sightseeing, photography, and ferry rides to Elephanta Island."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road known for its stunning sunset views and city lights. A cab from Pimple Saudagar to Mumbai makes it convenient to enjoy a relaxing drive or an evening stroll along this picturesque promenade."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is a popular seaside destination in Mumbai, famous for its sandy shores, vibrant atmosphere, and street food. Travelers arriving from Pimple Saudagar by cab can enjoy a comfortable trip directly to this lively beach."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple, dedicated to Lord Ganesha, is a revered spiritual site in Prabhadevi. Visitors traveling from Pimple Saudagar by cab often include this temple in their Mumbai itinerary for blessings and cultural exploration."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is an impressive bridge connecting Bandra and Worli with panoramic views of the sea and city skyline. Travelers using a cab from Pimple Saudagar can enjoy a smooth and scenic ride across this landmark."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous mosque and tomb located on a small island off Mumbai’s coast. A cab ride from Pimple Saudagar allows travelers to conveniently visit this serene spiritual site and enjoy the seaside ambience."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut temples on Elephanta Island, known for their intricate carvings and historical significance. Travelers can take a cab from Pimple Saudagar to the Gateway of India and then a ferry to explore this UNESCO World Heritage site."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve offering trekking trails, wildlife, and the historic Kanheri Caves. Travelers using a cab from Pimple Saudagar can access this green retreat for outdoor activities and relaxation."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a vibrant shopping street in South Mumbai, filled with markets, boutiques, and cafes. Travelers arriving from Pimple Saudagar by cab can explore this lively area for shopping, dining, and local culture."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraces on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Travelers from Pimple Saudagar can reach this serene spot easily by cab for relaxation and photography."
  }
],



services: [
{
name: "Pimple Saudagar to Mumbai Cab",
description: "Pimple Saudagar to Mumbai cab service offers reliable intercity transportation between Pune’s Pimple Saudagar area and Mumbai city. Comfortable vehicles with professional drivers ensure safe highway travel via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, and residential societies across Pimple Saudagar. Ideal for business travel, airport transfers, and family trips. Flexible booking options allow convenient cab reservations."
},
{
name: "Pimple Saudagar to Mumbai Airport Cab",
description: "Pimple Saudagar to Mumbai Airport cab service provides dependable transportation for passengers traveling to Mumbai Airport terminals. Vehicles offer comfortable seating and luggage space suitable for airport transfers. Professional drivers ensure punctual pickup and safe expressway travel. Pickup services are available from homes, offices, and hotels in Pimple Saudagar. Flexible booking options allow advance airport ride reservations."
},
{
name: "Pimple Saudagar to Mumbai International Airport",
description: "Pimple Saudagar to Mumbai International Airport cab service offers convenient transportation for passengers heading to Chhatrapati Shivaji Maharaj International Airport. Vehicles are well maintained and suitable for long-distance highway travel. Professional drivers ensure safe driving and timely arrival for flights. Pickup services are available across Pimple Saudagar. Flexible booking options allow convenient airport cab reservations."
},
{
name: "Pimple Gurav to Mumbai Cab Service",
description: "Pimple Gurav to Mumbai cab service offers reliable transportation between Pimple Gurav and Mumbai city. Comfortable vehicles with professional drivers ensure safe journeys via the expressway. Pickup services are available from homes, offices, and residential areas across Pimple Gurav. Ideal for business travel, tourism visits, and airport transfers. Flexible booking options allow convenient ride reservations."
},
{
name: "Taxi Service in Pimple Gurav",
description: "Taxi service in Pimple Gurav provides dependable transportation for local rides, airport transfers, and outstation journeys. Vehicles are comfortable and suitable for daily commuting or long-distance travel. Professional drivers ensure safe and punctual pickup services. Pickup services are available from homes, offices, and residential complexes across Pimple Gurav. Flexible booking options allow convenient taxi reservations."
},
{
name: "Taxi Service in Pimple Saudagar Pune",
description: "Taxi service in Pimple Saudagar Pune offers reliable local and outstation transportation with professional drivers and comfortable vehicles. Passengers can easily book cabs for airport transfers, city rides, and intercity travel. Pickup services are available from homes, offices, and hotels across Pimple Saudagar. Flexible booking options allow easy taxi reservations."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable airport transportation for travelers heading to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport travel. Professional drivers ensure safe driving and punctual pickup services across Pune. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for expressway travel. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys. Professional drivers ensure safe driving and punctual pickup services across Pune and Mumbai. Flexible booking options allow convenient ride reservations."
},
{
name: "Top-rated Mumbai to Pimple Saudagar Cabs",
description: "Top-rated Mumbai to Pimple Saudagar cabs provide comfortable and reliable transportation for passengers traveling from Mumbai to Pune’s Pimple Saudagar area. Vehicles are well maintained and suitable for long-distance expressway travel. Professional drivers ensure safe journeys and punctual pickup services. Flexible booking options allow convenient ride reservations."
},
{
name: "Pimple Saudagar to Dadar Cab Service",
description: "Pimple Saudagar to Dadar cab service provides reliable transportation for passengers traveling between Pune and Dadar in Mumbai. Comfortable vehicles with experienced drivers ensure safe highway travel. Pickup services are available from homes, offices, and residential societies across Pimple Saudagar. Flexible booking options allow easy cab reservations."
},
{
name: "Pimple Gurav to Dadar Cab Service",
description: "Pimple Gurav to Dadar cab service offers dependable transportation between Pimple Gurav and Dadar in Mumbai. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, and residential areas across Pimple Gurav. Flexible booking options allow convenient ride reservations."
},
{
name: "Cab Service in Pimple Gurav",
description: "Cab service in Pimple Gurav provides reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles with professional drivers ensure safe and smooth rides. Pickup services are available from homes, offices, and residential complexes across Pimple Gurav. Flexible booking options allow convenient taxi reservations."
},
{
name: "Innova Crysta on Rent in Pimple Saudagar Pune",
description: "Innova Crysta on rent in Pimple Saudagar Pune offers premium SUV rental for travelers seeking luxury transportation. The Innova Crysta provides spacious seating and smooth ride quality suitable for long-distance travel and airport transfers. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient SUV rental."
},
{
name: "Pimple Saudagar to Andheri Cab",
description: "Pimple Saudagar to Andheri cab service offers dependable transportation between Pimple Saudagar and Andheri in Mumbai. Vehicles are comfortable and suitable for long-distance highway travel. Professional drivers ensure safe journeys and punctual pickup services. Flexible booking options allow easy cab reservations."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip service provides convenient return transportation for travelers planning trips between Pune and Mumbai. Comfortable vehicles with experienced drivers ensure safe journeys via the expressway. Flexible booking options allow easy round-trip cab reservations."
},
{
name: "Ertiga on Rent in Pimple Saudagar",
description: "Ertiga on rent in Pimple Saudagar service offers spacious SUV rental for families and group travelers. The Ertiga vehicle provides comfortable seating and luggage space suitable for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Pune. Flexible booking options allow convenient SUV hire."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel across Pune and nearby destinations. Flexible booking options allow convenient taxi reservations."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable intercity transportation between Pune and Mumbai via the expressway. Vehicles are comfortable and suitable for long-distance travel with experienced drivers ensuring safe journeys. Flexible booking options allow easy cab reservations."
},
{
name: "Cab Service Pimple Saudagar Pune",
description: "Cab service Pimple Saudagar Pune offers reliable transportation for local rides, airport transfers, and outstation travel. Comfortable vehicles with professional drivers ensure safe journeys across Pune and nearby cities. Pickup services are available from homes, offices, and residential societies across Pimple Saudagar."
},
{
name: "Pimple Saudagar to Mumbai Cabs",
description: "Pimple Saudagar to Mumbai cabs service provides reliable intercity transportation between Pimple Saudagar and Mumbai city. Vehicles are well maintained and suitable for expressway travel with professional drivers ensuring safe journeys. Flexible booking options allow convenient ride reservations."
},
{
name: "Pimple Saudagar to Mumbai Taxi",
description: "Pimple Saudagar to Mumbai taxi service offers dependable transportation for passengers traveling between Pimple Saudagar and Mumbai. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys. Flexible booking options allow easy taxi reservations."
}
],

tableData: [
["Pimple Saudagar to Mumbai Cab","Pimple Saudagar to Mumbai Airport Cab"],
["Pimple Saudagar to Mumbai International Airport","Pimple Gurav to Mumbai Cab Service"],
["Taxi Service in Pimple Gurav","Taxi Service in Pimple Saudagar Pune"],
["Pune to Mumbai Airport Cab","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Top-rated Mumbai to Pimple Saudagar Cabs"],
["Pimple Saudagar to Dadar Cab Service","Pimple Gurav to Dadar Cab Service"],
["Cab Service in Pimple Gurav","Innova Crysta on Rent in Pimple Saudagar Pune"],
["Pimple Saudagar to Andheri Cab","Pune to Mumbai Cab Round Trip"],
["Ertiga on Rent in Pimple Saudagar","Cab Service in Pune"],
["Pune Mumbai Cab","Cab Service Pimple Saudagar Pune"],
["Pimple Saudagar to Mumbai Cabs","Pimple Saudagar to Mumbai Taxi"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Pimple Saudagar to Mumbai through the Mumbai Pune Expressway. Their knowledge of traffic routes and highway conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Pimple Saudagar to Mumbai cab service. Customers receive complete fare details including toll charges and driver allowance before confirming their booking."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Pimple Saudagar to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Pimple Saudagar to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Pimple Saudagar",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and residential societies across Pimple Saudagar and nearby areas like Wakad, Rahatani, Vishal Nagar, and Aundh."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Pimple Saudagar to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Pimple Saudagar to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Pimple Saudagar to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Pimple Saudagar to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "What is the distance from Pimple Saudagar to Mumbai?", answer: "The distance from Pimple Saudagar to Mumbai is around 135–150 km and the journey usually takes about 3–4 hours depending on traffic." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pimple Saudagar to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Pimple Saudagar and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential societies across Pimple Saudagar." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Pimple Saudagar to Mumbai cab services online or through phone booking." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and all major areas across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "A very comfortable and well-managed journey from Pimple Saudagar to Mumbai. The cab was punctual, clean, and the ride felt smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Pimple Saudagar to Mumbai cab service was reliable and hassle-free. The vehicle was well-maintained, and the overall travel experience felt safe and relaxed.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimple Saudagar to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Pimple Saudagar to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Innova Crysta for airport transfers, Dadar, Andheri, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Pimple Saudagar to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Pimple Saudagar to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pimple Saudagar to Mumbai cab with Velocity Cabs. Affordable taxi service for one way, round trip & airport drop. Ertiga, Innova & Crysta cabs available for Dadar, Andheri, Mumbai airport & more." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimplessaudagartomumbaicab;